import React from "react";

const Blog1 = () => {
  return (
    <>
      <p className="text-lg leading-relaxed text-gray-700 mb-4">
        In today's fast-paced digital world, video conferencing tools have
        become essential for seamless communication. Whether you're connecting
        with colleagues, hosting a webinar, or conducting an online class,
        Konn3ct is your go-to solution for high-quality video meetings. In this
        guide, we'll walk you through how to use Konn3ct effectively and make
        the most of its features.{" "}
      </p>

      <p className="text-lg leading-relaxed text-gray-700 mb-6">
        In this guide, we'll walk you through how to use Konn3ct effectively and
        make the most of its features.{" "}
      </p>

      <section className="mt-10 space-y-6">
        {/* Getting Started */}
        {/* <h2 className="text-2xl font-semibold mt-8">
          Getting Started with Konn3ct
        </h2> */}
        <h1 className="text-3xl font-bold mb-8 text-[#1A4699]">
          Getting Started with Konn3ct
        </h1>
        <p className="text-gray-700">
          Before diving into the details, you’ll first need to download and set
          up Konn3ct on your device. Here’s how to get started:
        </p>

        {/* Step 1 */}
        <h3 className="text-xl font-semibold">Step 1: Download the App</h3>
        <ul className="list-disc pl-6 text-gray-700 space-y-2">
          <li>
            Open your device’s app store (Google Play Store or Apple App Store).
          </li>
          <li>
            Search for <strong className="text-[#1A4699]">Konn3ct by Newwaves Ecosystem Limited</strong>.
          </li>
          <li>Download and install the app.</li>
          <li>If already installed, simply open the app.</li>
        </ul>

        {/* Step 2 */}
        <h3 className="text-xl font-semibold mt-5">
          Step 2: Create Your Account
        </h3>
        <ul className="list-disc pl-6 text-gray-700 space-y-2">
          <li>
            Open the app and tap the   {" "}
             <a
            href="https://dashboard.konn3ct.com/register"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:text-blue-800"
          >
           Sign Up {" "}
          </a>
            button.
          </li>
         
          <li>
            Select whether you're signing up as an individual or business.
          </li>
          <li>Enter your email address and create a secure password.</li>
          <li>
            If you already have an account, tap  {" "}
             <a
            href="https://dashboard.konn3ct.com/login"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:text-blue-800"
          >
         Login {" "}
          </a>
            
             and enter
            your credentials.
          </li>
        </ul>

        {/* Dashboard Navigation */}
        <h2 className="text-2xl font-semibold mt-8">
          Navigating the Konn3ct Dashboard
        </h2>
        {/* <p className="text-gray-700">
          Once you sign in, the dashboard presents three main options:
        </p> */}
        <p className="text-gray-700">
          Once you{" "}
          <a
            href="https://dashboard.konn3ct.com/login"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline hover:text-blue-800"
          >
            sign in
          </a>
          , the dashboard presents three main options:
        </p>
        <ul className="list-disc pl-6 text-gray-700 space-y-2">
          <li>
            <strong>Join a Meeting</strong>
          </li>
          <li>
            <strong>Host a Meeting</strong>
          </li>
          <li>
            <strong>Konn3ct EDU</strong> — a specialized solution for schools
          </li>
        </ul>

        {/* Join a meeting */}
        <h3 className="text-xl font-semibold mt-5">Option 1: Join a Meeting</h3>
        <p className="text-gray-700">To join a meeting:</p>
        <ul className="list-disc pl-6 text-gray-700 space-y-2">
          <li>
            Click <strong>Join a Meeting</strong>.
          </li>
          <li>Enter the Meeting ID provided by the host.</li>
          <li>Fill in your name and email.</li>
          <li>
            Click <strong>Join Meeting</strong>.
          </li>
        </ul>
        <p className="text-gray-700">
          You can also join directly by clicking on the host’s meeting link.
        </p>

        {/* Host a meeting */}
        <h3 className="text-xl font-semibold mt-5">Option 2: Host a Meeting</h3>
        <p className="text-gray-700">To host a meeting:</p>
        <ul className="list-disc pl-6 text-gray-700 space-y-2">
          <li>
            Click <strong>Host a Meeting</strong>.
          </li>
          <li>
            Create a meeting room by tapping the <strong>+</strong> button.
          </li>
          <li>
            Name your room and tap <strong>Create</strong>.
          </li>
          <li>Select the room to begin your meeting.</li>
        </ul>

        {/* Features */}
        <h2 className="text-2xl font-semibold mt-8">
          Essential Features of Konn3ct
        </h2>

        <h3 className="text-lg font-semibold mt-4">
          Mute/Unmute & Camera Controls
        </h3>
        <p className="text-gray-700">
          Easily toggle your audio and video during meetings. If you prefer not
          to show your face, simply turn off your camera.
        </p>

        <h3 className="text-lg font-semibold mt-4">Recording Meetings</h3>
        <p className="text-gray-700">
          Pro users can record meetings for future reference. Visit{" "}
<a
            href="https://dashboard.konn3ct.com/login"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 font-semibold hover:text-blue-800"
          >
            konn3ct.com
          </a>{" "}          to upgrade.
        </p>

        <h3 className="text-lg font-semibold mt-4">Hand Raising</h3>
        <p className="text-gray-700">
          Use the hand-raising feature to ask questions or participate without
          interrupting others.
        </p>

        {/* Collaboration tools */}
        <h2 className="text-2xl font-semibold mt-8">
          Advanced Collaboration Tools
        </h2>

        <ul className="list-disc pl-6 text-gray-700 space-y-2">
          <li>
            <strong>Screen Sharing:</strong> Share presentations or documents
            instantly.
          </li>
          <li>
            <strong>Group Chat:</strong> Send messages and links without
            disrupting the meeting.
          </li>
          <li>
            <strong>Konn3ct Doc:</strong> Collaborate on documents in real time.
          </li>
          <li>
            <strong>Breakout Rooms:</strong> Split participants into smaller
            groups.
          </li>
          <li>
            <strong>Polling & Random Selector:</strong> Collect opinions or
            randomly pick participants.
          </li>
        </ul>

        {/* Managing participants */}
        <h2 className="text-2xl font-semibold mt-8">Managing Participants</h2>

        <ul className="list-disc pl-6 text-gray-700 space-y-2">
          <li>
            <strong>Mute All:</strong> Useful for large meetings.
          </li>
          <li>
            <strong>Grant Presenter Rights:</strong> Allow others to share
            screens or lead discussions.
          </li>
          <li>
            <strong>Lock Meeting:</strong> Prevent additional joiners.
          </li>
          <li>
            <strong>Take Attendance:</strong> Automatically track who joined.
          </li>
        </ul>

        {/* EDU section */}
        <h2 className="text-2xl font-semibold mt-8">
          Integrating Konn3ct EDU for Schools
        </h2>
        <p className="text-gray-700">
          Konn3ct EDU provides virtual classrooms, interactive whiteboards,
          attendance tracking, polling, quizzes, and more—designed specifically
          for teachers and students.
        </p>

        {/* Tips */}
        <h2 className="text-2xl font-semibold mt-8">
          Pro Tips for Using Konn3ct
        </h2>

        <ul className="list-disc pl-6 text-gray-700 space-y-2">
          <li>Ensure a stable internet connection.</li>
          <li>Upgrade to Pro for advanced features.</li>
          <li>Test your audio and video before joining meetings.</li>
          <li>Explore new features — Konn3ct updates frequently.</li>
        </ul>

        {/* Troubleshooting */}
        <h2 className="text-2xl font-semibold mt-8">
          Troubleshooting Common Issues
        </h2>

        <ul className="list-disc pl-6 text-gray-700 space-y-2">
          <li>
            <strong>Can’t Join:</strong> Recheck the Meeting ID or ensure the
            host has started the session.
          </li>
          <li>
            <strong>Audio/Video Problems:</strong> Allow permissions for camera
            and microphone.
          </li>
          <li>
            <strong>App Crashes:</strong> Update the app or restart your device.
          </li>
        </ul>

        {/* Why Choose Konn3ct */}
        <h2 className="text-2xl font-semibold">Why Choose Konn3ct?</h2>
        <p className="text-gray-700">
          Konn3ct is specifically designed to cater to the needs of Nigerian
          users. Here's why it stands out:
        </p>

        <ul className="list-disc pl-6 text-gray-700 space-y-2">
          <li>
            <strong>Affordable Pricing:</strong> Unlike other platforms that
            require dollar payments, Konn3ct offers local pricing that fits
            perfectly into the Nigerian market.
          </li>
          <li>
            <strong>Free One-Hour Meetings:</strong> Every new user gets an hour
            of free video conferencing immediately after signing up.
          </li>
          <li>
            <strong>Robust Features:</strong> From group chats to collaborative
            documents, Konn3ct offers everything needed for smooth
            communication.
          </li>
          <li>
            <strong>No Dollar Payments Needed:</strong> No need to worry about
            sourcing foreign currency—simply pay in Naira.
          </li>
        </ul>

        {/* Conclusion */}
        <h2 className="text-xl font-semibold mt-8">Conclusion</h2>
        <p className="text-gray-700">
          Konn3ct is more than just a video conferencing tool—it’s a
          comprehensive platform designed to enhance communication,
          collaboration, and productivity. Whether you're hosting a meeting,
          joining one, or using Konn3ct EDU for education, the platform equips
          you with all the tools you need to succeed.{" "}
        </p>
        <p className="text-gray-700">
          If you haven’t tried Konn3ct yet, download the app today and
          experience the difference. For any questions or feedback, drop a
          comment below—we’d love to hear from you!{" "}
        </p>

        {/* <p className="text-gray-700 font-semibold text-lg mt-4">
          Ready to get started? Visit{" "}
          <span className="text-blue-600">konn3ct.com</span> today,{" "}
          <span className="text-blue-600">sign up</span> 
        </p> */}

        <p className="text-gray-700 font-semibold text-lg mt-4">
          Ready to get started? Visit{" "}
          <a
            href="https://dashboard.konn3ct.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:text-blue-800"
          >
            konn3ct.com
          </a>{" "}
          today,{" "}
          <a
            href="https://dashboard.konn3ct.com/register"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline hover:text-blue-800"
          >
            sign up
          </a>{" "}
          for free, and connect like never before!
        </p>
      </section>
    </>
  );
};

export default Blog1;
